/*!
 * Copyright © 2026 Dolphin & Dog Pty Ltd. All rights reserved.
 *
 * This custom code may not be copied, reproduced, modified, distributed,
 * sold, or used commercially without prior written permission from
 * Dolphin & Dog Pty Ltd, except as permitted by law.
 */
(function(){
  var scriptVersion='gift-box-remove-v4';

  if(window.__giftBoxCartRemoveVersion===scriptVersion){
    return;
  }

  window.__giftBoxCartRemoveVersion=scriptVersion;

  document.addEventListener('click',async function(event){
    var button=event.target.closest('[data-gift-box-remove]');

    if(!button)return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if(button.dataset.removing==='true'){
      return;
    }

    var keys=(button.getAttribute('data-line-keys')||'')
      .split('||')
      .filter(Boolean);

    if(!keys.length){
      alert(
        'Sorry, this gift box could not be removed. Please refresh the cart and try again.'
      );
      return;
    }

    var updates={};

    keys.forEach(function(key){
      updates[key]=0;
    });

    var row=button.closest(
      '.gift-box-cart-group, '+
      '.cart__items__row, '+
      '[data-cart-item]'
    );

    var checkoutButtons=document.querySelectorAll(
      '[name="checkout"], '+
      '[href="/checkout"], '+
      '[data-cart-checkout]'
    );

    button.dataset.removing='true';
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    button.textContent='Removing...';

    if(row){
      row.style.opacity='0';
      row.style.pointerEvents='none';
      row.style.transition='opacity 160ms ease';
    }

    checkoutButtons.forEach(function(checkoutButton){
      checkoutButton.disabled=true;
      checkoutButton.setAttribute('aria-disabled','true');
    });

    try{
      var root=
        window.Shopify&&
        Shopify.routes&&
        Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      var response=await fetch(root+'cart/update.js',{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          updates:updates
        })
      });

      if(!response.ok){
        throw new Error(await response.text());
      }

      window.location.reload();

    }catch(error){
      console.error('Gift box removal failed:',error);

      button.dataset.removing='false';
      button.disabled=false;
      button.removeAttribute('aria-busy');
      button.textContent='Remove gift box';

      if(row){
        row.style.opacity='';
        row.style.pointerEvents='';
      }

      checkoutButtons.forEach(function(checkoutButton){
        checkoutButton.disabled=false;
        checkoutButton.removeAttribute('aria-disabled');
      });

      alert(
        'Sorry, this gift box could not be removed. Please refresh the cart and try again.'
      );
    }
  },true);
})();